
import { useState,useEffect } from "react";

import eye from "../eye.png";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputPassword(props)
{
    var def = null;
    if(props.userData!=undefined) def = props.userData.refreshView;
    const [refreshView, setRefreshView] = useState(def);
    

    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [visible, setVisible] = useState('password');

    const [onShow,setOnShow] = useState(false);


    const changeVisible = () => {

        if(visible == "password")
        {
            setVisible('text');
        }else  setVisible('password');
       
    }


    const validate = (pw) => { 

        return /[A-Z]/.test(pw) &&
        /[a-z]/       .test(pw) &&
        /[0-9]/       .test(pw) &&
        /[^A-Za-z0-9]/.test(pw) &&
        pw.length > 5;

        
      };


    const checkAndChange = (e,newVal) =>
    {
        if(e != null && e != undefined)
        {
          var v = e.target.value;
          setVal(v);
        }else
        {
            v =  newVal;
        }

        var correct = false;

        if(req == '1' && v.length < 1) correct = false;         
        if(req == '0' && v.length < 1) correct = true;
        

        if(v.length > 0 && validate(v) )
        {
            correct = true;
        }
                        
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }

    }


    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    const randPass = () => {

        var back   = "";
        var h      = "Q!@#WE1q$%^&wER*()T_+YeUIOPrtASDyFFuGHJKLi:\"2ASDFGopHJKL:\"[]3ZXCVBNa4sdfgNM<>?5hjkl6;'7zxc8vb,./mnn90"
        var nums   = "1234567890";
        var upper = "QWERTYUIOPASDFGHJKLZXCVBNM";
        var lower  = "qwertyuiopasdfghjklzxcvbnm";
        var spec  = "!@#$%^&*()_+";


        var arrR       = h.split('');
        var arrNums    = nums.split('');
        var arrUppoer  = upper.split('');
        var arrLower   = lower.split('');
        var arrSpec    = spec.split('');
       
      
        for(var k=0; k<2; k++)
        {

            var hh = Math.floor(Math.random() * arrR.length);
            hh = arrR[hh];
            back = back + hh;

            hh = Math.floor(Math.random() * arrNums.length);
            hh = arrNums[hh];
            back = back + hh;

            hh = Math.floor(Math.random() * arrUppoer.length);
            hh = arrUppoer[hh];
            back = back + hh;

            hh = Math.floor(Math.random() * arrLower.length);
            hh = arrLower[hh];
            back = back + hh;

            hh = Math.floor(Math.random() * arrSpec.length);
            hh = arrSpec[hh];
            back = back + hh;
        }

        var hh = Math.floor(Math.random() * arrR.length);
        hh = arrR[hh];
        back = back + hh;
        

       // tmpRow["haslo"] = back;
       // tmpRow["haslo_valid"] = true;         
       // setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
       
       checkAndChange(null, back);
       setVisible('text');

    }



    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' &&  val != undefined  &&  !validate(val) ) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })
    




    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }


    var cnX = cn;
    if(val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    var defClass = " w250 ";
    if(props.className != undefined ) defClass = props.className;    

    return <fieldset>
             <input type={visible}  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={defClass+ "  " + cnX } />                        
             <br/>
             <span className="passeye" onClick={changeVisible}><img src={eye} /></span>
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>
             {
                props.rand &&
                <span className="link_color" onClick={randPass}>
                    wylosuj hasło
                </span>
             }
          </fieldset>
}


export default InputPassword;